import api from './axiosInstance';

export const getCropRawListApi   = (params)      => api.get('/crop-raw/list', { params });
export const getCropRawDetailApi = (id)           => api.get(`/crop-raw/detail/${id}`);
export const createCropRawApi    = (data)         => api.post('/crop-raw/store', data);
export const updateCropRawApi    = (id, data)     => api.post(`/crop-raw/update/${id}`, data);
export const deleteCropRawApi    = (id)           => api.delete(`/crop-raw/delete/${id}`);
